import { render, staticRenderFns } from "./epc.vue?vue&type=template&id=45e8b742"
import script from "./epc.vue?vue&type=script&lang=js"
export * from "./epc.vue?vue&type=script&lang=js"
import style0 from "./epc.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports